import { API_URL } from '../settings/app.settings'
import axios from 'axios'

export const $httpns = axios.create({
  baseURL: API_URL,
  headers: { 'content-type': 'application/json' },
})
